import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';
import { deepClone } from '@/utils/function_utils';
import path from 'path';
Vue.use(VueRouter);

/**
 * ConstantRoutes
 * 没有权限需求的基本页面路由，所有角色都可以访问
 */
export const constantRoutes: RouteConfig[] = [
  {
    path: '/404',
    name: 'error',
    meta: { hidden: true },
    component: () => import(/* webpackChunkName: "error" */ '@/views/error-page/error.vue'),
  },
  {
    path: '/redirect',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect/index.vue'),
      },
    ],
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: {
      icon: 'home',
      title: 'index',
      hidden: true,
      canClick: true, // 有嵌套路由时，是否可以为路由的一级侧栏
    },
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "index" */ '../views/index/Index.vue'),
        meta: {
          hidden: true,
          activeMenu: '/',
        },
      },
    ]
  },
  {
    path: '/hk',
    component: Layout,
    redirect: '/hk',
    meta: {
      title: 'HK',
      titleCN: '香港',
      titleZH: '香港',
      hidden: false,
      canClick: true, // 有嵌套路由时，是否可以为路由的一级侧栏
    },
    children: [
      {
        path: '/hk',
        name: 'hk',
        component: () => import(/* webpackChunkName: "index" */ '../views/index/HK.vue'),
        meta: {
          hidden: true,
          activeMenu: '/',
        },
      },
    ]
  },
  {
    path: '/sg',
    component: Layout,
    redirect: '/sg',
    meta: {
      title: 'SG',
      titleCN: '新加坡',
      titleZH: '新加坡',
      hidden: false,
      canClick: true, // 有嵌套路由时，是否可以为路由的一级侧栏
    },
    children: [
      {
        path: '/sg',
        name: 'sg',
        component: () => import(/* webpackChunkName: "index" */ '../views/index/SG.vue'),
        meta: {
          hidden: true,
          activeMenu: '/',
        },
      },
    ]
  },
  // {
  //   path: '/k12',
  //   component: Layout,
  //   redirect: '/k12',
  //   meta: {
  //     title: 'K12',
  //     titleCN: 'K12',
  //     titleZH: 'K12',
  //     hidden: false,
  //     canClick: true, // 有嵌套路由时，是否可以为路由的一级侧栏
  //   },
  //   children: [
  //     {
  //       path: '/k12',
  //       name: 'k12',
  //       component: () => import(/* webpackChunkName: "index" */ '../views/index/K12.vue'),
  //       meta: {
  //         hidden: true,
  //         activeMenu: '/',
  //       },
  //     },
  //   ]
  // },
];

// 异步路由
export const asyncRoutes: RouteConfig[] = [
  { path: '*', redirect: '/404' },
];
const createRouter = () => new VueRouter({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      // 当且仅当 popstate 导航 (通过浏览器的 前进/后退 按钮触发) 时才可用
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRoutes,
});

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher;
}

// 二级以上的菜单降级成二级菜单
const formatRouter = (routes: any, basePath = '/', list: any[] = [], parent: any) => {
  routes.map((item: any) => {
    item.path = path.resolve(basePath, item.path)
    const meta = item.meta || {};
    if (!meta.parent && parent) {
      meta.parent = parent.path;
      item.meta = meta;
    }
    if (item.redirect && item.redirect !== 'noRedirect') {
      item.redirect = path.resolve(basePath, item.redirect)
    }
    if (item.children && item.children.length > 0) {
      const arr = formatRouter(item.children, item.path, list, item);
      delete item.children;
      list.concat(arr);
    }
    list.push(item);
  })
  return list
}

// 菜单降级
export const getFlatRoutes = (routes: RouteConfig[]) => {
  return routes.map((child: RouteConfig) => {
    if (child.children && child.children.length > 0) {
      child.children = formatRouter(child.children, child.path, [], child);
    }
    return child;
  })
}

// 降级后的路由
export const flatRoutes = getFlatRoutes(deepClone(asyncRoutes, ['component']));

export default router;
